import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuardService implements CanActivate {

  constructor(public auth: AuthenticationService, public router: Router) { }

  canActivate(): boolean {
    if (!this.auth.isAuthenticated()) {
      // console.log('not authenticated');
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}
